import { createReducer } from "@reduxjs/toolkit";
import {
	API_GET_ALL_CENTER,
	API_GET_ALL_CENTER_FAIL,
	API_GET_ALL_CENTER_SUCCESS,
	RESET_CENTER,
	SET_CENTER,
	API_GET_MY_CENTERS,
	API_GET_MY_CENTERS_SUCCESS,
	API_GET_MY_CENTERS_FAIL,
	API_GET_CENTER_TOUR_STATUS_SUCCESS,
	API_GET_CENTER_TOUR_STATUS_FAIL,
	API_GET_APPOINTMENTS_FOR_CENTER_FAIL,
} from "actions/center";
import { errorHandler, ErrorAction } from "utils/error";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	my: [],
	loading: false,
	exists: null,
	center: null,
	tour: null,
};

const centers = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_CENTER]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_CENTER_FAIL]: (state, action) => {
		errorHandler("Centre", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_CENTER_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},

	[API_GET_MY_CENTERS]: (state, action) => {
		state.loading = true;
	},

	[API_GET_MY_CENTERS_FAIL]: (state, action) => {
		errorHandler("Centre", ErrorAction.READ, action.error);
		state.loading = false;
	},

	[API_GET_MY_CENTERS_SUCCESS]: (state, action) => {
		state.loading = false;
		state.my = action.payload.data;
	},

	[SET_CENTER]: (state, action) => {
		state.center = action.payload;
	},

	[RESET_CENTER]: (state, action) => {
		state.center = null;
	},

	[API_GET_CENTER_TOUR_STATUS_SUCCESS]: (state, action) => {
		state.tour = action.payload.data;
	},
	[API_GET_CENTER_TOUR_STATUS_FAIL]: (state, action) => {
		state.tour = null;
	},
	[API_GET_APPOINTMENTS_FOR_CENTER_FAIL]: (state, action) => {
		toast.error("Impossible de récupérer les rendez-vous pour la semaine. Veuillez réessayer plus tard.");
	},
});

export default centers;
